

const PersonalInformation = ({ formData, handleInputChange, errors }) => (
  <div className='form-section'>
    <div className='section-header'>
      <div className='section-icon'>👤</div>
      <h3>Personal Information</h3>
    </div>
    <div className='form-grid'>
      <div className='form-group'>
        <label htmlFor='firstName'>First Name</label>
        <input
          type='text'
          id='firstName'
          name='firstName'
          value={formData.firstName}
          onChange={handleInputChange}
          className={errors.firstName ? 'error' : ''}
          placeholder='Enter your first name'
        />
        {errors.firstName && (
          <span className='error-text'>{errors.firstName}</span>
        )}
      </div>
      <div className='form-group'>
        <label htmlFor='lastName'>Last Name</label>
        <input
          type='text'
          id='lastName'
          name='lastName'
          value={formData.lastName}
          onChange={handleInputChange}
          className={errors.lastName ? 'error' : ''}
          placeholder='Enter your last name'
        />
        {errors.lastName && (
          <span className='error-text'>{errors.lastName}</span>
        )}
      </div>
    </div>
    <div className='form-grid'>
      <div className='form-group'>
        <label htmlFor='email'>Email Address</label>
        <input
          type='email'
          id='email'
          name='email'
          value={formData.email}
          onChange={handleInputChange}
          className={errors.email ? 'error' : ''}
          placeholder='Enter your email address'
        />
        {errors.email && <span className='error-text'>{errors.email}</span>}
      </div>
      <div className='form-group'>
        <label htmlFor='phone'>Phone Number</label>
        <input
          type='tel'
          id='phone'
          name='phone'
          value={formData.phone}
          onChange={handleInputChange}
          className={errors.phone ? 'error' : ''}
          placeholder='+234 or 0801234567'
        />
        {errors.phone && <span className='error-text'>{errors.phone}</span>}
      </div>
    </div>
  </div>
);

export default PersonalInformation;
